import React, { useState, useEffect } from 'react';
import { Layout, Avatar, Typography, Button } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LimsNavIcon } from '../components/LimsNavIcon';
import '../components/TopNavbar.css';

const { Header } = Layout;
const { Text } = Typography;

interface MerchantTopNavbarProps {
  onToggleSidebar?: () => void;
}

/**
 * 商家端顶栏：视觉对齐实验室 TopNavbar，功能裁剪为商家信息与退出。
 */
const MerchantTopNavbar: React.FC<MerchantTopNavbarProps> = ({ onToggleSidebar }) => {
  const { logout, username, realName } = useAuth();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const merchantName = localStorage.getItem('merchantName') || '商家端';
  const merchantCode = localStorage.getItem('merchantCode') || '';

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleLogout = () => {
    logout();
    localStorage.removeItem('merchantId');
    localStorage.removeItem('merchantName');
    localStorage.removeItem('merchantCode');
    navigate('/merchant/login');
  };

  return (
    <Header className="lims-top-navbar top-navbar">
      <div className="lims-top-inner">
        <div className="lims-top-left">
          {isMobile && (
            <Button
              type="text"
              className="lims-mobile-menu"
              icon={<LimsNavIcon name="menu" sizePx={22} />}
              onClick={onToggleSidebar}
            />
          )}
          <Button type="text" className="lims-team-switcher" style={{ maxWidth: isMobile ? 120 : 280 }}>
            <LimsNavIcon name="storefront" sizePx={20} className="lims-team-switcher-icon" />
            {!isMobile && (
              <span className="lims-team-switcher-name">
                {merchantName}
                {merchantCode ? ` · ${merchantCode}` : ''}
              </span>
            )}
          </Button>
        </div>

        {!isMobile && (
          <div className="lims-top-center">
            <div className="lims-global-search" style={{ opacity: 0.55, pointerEvents: 'none' }}>
              <LimsNavIcon name="search" sizePx={18} className="lims-global-search-icon" />
              <input
                type="search"
                className="lims-global-search-input"
                placeholder="商家端订单可在「订单管理」中筛选"
                disabled
                aria-label="商家端搜索占位"
              />
            </div>
          </div>
        )}

        <div className="lims-top-right">
          {!isMobile ? (
            <div className="lims-user-block">
              <Avatar
                size={32}
                icon={<LimsNavIcon name="storefront" sizePx={18} />}
                style={{
                  backgroundColor: 'rgba(0, 53, 95, 0.1)',
                  color: 'var(--lims-primary)'
                }}
              />
              <div className="lims-user-meta">
                <Text strong style={{ fontSize: 14, color: 'var(--lims-on)' }}>
                  {realName || username || '商家'}
                </Text>
                <Text style={{ fontSize: 12, color: 'var(--lims-on-variant)' }}>商家</Text>
              </div>
            </div>
          ) : (
            <Avatar
              size={32}
              icon={<LimsNavIcon name="storefront" sizePx={18} />}
              style={{ backgroundColor: 'rgba(0, 53, 95, 0.1)' }}
            />
          )}

          <Button
            type="text"
            className="lims-logout"
            icon={<LimsNavIcon name="logout" sizePx={20} />}
            onClick={handleLogout}
          >
            {!isMobile && '退出'}
          </Button>
        </div>
      </div>
    </Header>
  );
};

export default MerchantTopNavbar;
